import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {AbstractControl, FormBuilder, FormGroup} from "@angular/forms";
import {StockService} from "../../services/stock.service";
import {Stock} from "../../../shared/view-model/stock";
import {Depot} from "../../../shared/view-model/store-management/depot.type";
import {debounceTime, distinctUntilChanged, switchMap} from "rxjs/operators";

@Component({
  selector: 'vb-stock-search',
  templateUrl: './stock-search.component.html',
  styleUrls: ['./stock-search.component.css']
})
export class StockSearchComponent implements OnInit {

  @Input()
  depot?: Depot;

  searchForm: FormGroup;
  searchTerm: AbstractControl;

  @Output()
  foundStocks: EventEmitter<Stock[]> = new EventEmitter<Stock[]>();


  constructor(private fb: FormBuilder,
              private stockService: StockService) {

    this.searchForm = this.fb.group({
      'searchTerm': [null]
    });
    this.searchTerm = this.searchForm.controls['searchTerm'];

  }

  ngOnInit() {

    this.searchTerm.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(term => {
        console.info('New term: ' + term);
        if (this.depot) {
          return this.stockService.searchStocks(term, this.depot.cuid);
        } else {
          return this.stockService.searchStocks(term);
        }
      })
    )
      .subscribe((res: any) => {
        console.info("Found stocks: " + JSON.stringify(res.stocks));
        this.onStocksFound(res.stocks);
      });


    /*
     .subscribe((st: any) =>{
     console.info('Found stocks: ' + JSON.stringify(st));
     this.onStocksFound(st);
     });
     */
  }

  onStocksFound(stocks: Stock[]) {
    this.foundStocks.emit(stocks);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/stock-search/stock-search.component.ts